<template>
  <section class="w-full cards fixed z-40">
    <nav
      class="justify-between py-5 items-center lg:container md:max-w-[85%] mx-auto md:flex"
    >
      <div class="h-full w-[80px] md:w-[120px] lg:w-[200px]">
        <router-link to="/"
          ><img src="/images/logo-white.png" alt="lubxoil logo"
        /></router-link>
      </div>
      <ul class="flex items-center sm:gap-5 lg:gap-8">
        <router-link to="/home">
          <li
            class="capitalize text-xs md:text-sm lg:text-lg cursor-pointer hover:text-secondary"
            :class="active.includes('home') ? 'text-secondary' : 'text-white'"
          >
            Home
          </li></router-link
        >
        <router-link to="/about"
          ><li
            class="capitalize text-xs md:text-sm lg:text-lg cursor-pointer hover:text-secondary"
            :class="active.includes('about') ? 'text-secondary' : 'text-white'"
          >
            About Us
          </li></router-link
        >
        <li
          class="capitalize text-white text-xs md:text-sm lg:text-lg cursor-pointer hover:text-secondary"
        >
          <popper
            arrow
            :hover="true"
            :placement="'bottom'"
            class="hover:text-secondary"
            :class="
              active.includes('products') ? 'text-secondary' : 'text-white'
            "
          >
            products

            <template #content>
              <div class="w-[200px] my-2">
                <router-link to="/products/automobile">
                  <div
                    class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades border-b"
                    :class="active.includes('automobile') ? 'bg-secondary' : ''"
                  >
                    Automobile Oils
                  </div></router-link
                >
                <router-link to="/products/industrial">
                  <div
                    class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades border-b"
                    :class="active.includes('industrial') ? 'bg-secondary' : ''"
                  >
                    Industrial Oils
                  </div></router-link
                >
                <router-link to="/products/greases">
                  <div
                    class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades border-b"
                    :class="active.includes('greases') ? 'bg-secondary' : ''"
                  >
                    Greases
                  </div></router-link
                >
                <router-link to="/products/quality-control">
                  <div
                    class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades"
                    :class="
                      active.includes('quality-control') ? 'bg-secondary' : ''
                    "
                  >
                    Quality Control
                  </div></router-link
                >
              </div>
            </template>
          </popper>
        </li>
        <router-link to="/careers"
          ><li
            class="capitalize text-xs md:text-sm cursor-pointer lg:text-lg hover:text-secondary"
            :class="
              active.includes('careers') ? 'text-secondary' : 'text-white'
            "
          >
            Careers
          </li></router-link
        >
        <router-link to="/contact">
          <li
            class="capitalize text-xs md:text-sm cursor-pointer lg:text-lg hover:text-secondary"
            :class="
              active.includes('contact') ? 'text-secondary' : 'text-white'
            "
          >
            Contact
          </li></router-link
        >
      </ul>
      <div>
        <a href="/docs/product-cert.pdf" download>
          <button
            class="border border-secondary py-2 px-5 rounded text-sm md:text-base text-capitalize text-secondary hover:bg-secondary hover:text-white"
          >
            products certificate
          </button>
        </a>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  components: {
    //
  },

  data() {
    return {};
  },

  computed: {
    active() {
      return this.$route.path;
    },
  },
};
</script>
